import {animateScrollTo, fireConfetti, fireRequest, formToJSON, getComonRequestMessage, notifyError, renderIntlPhoneNumber, toggleScroll} from "@/modules/utils";
import {Block} from "notiflix";

const globalListeners = () => {
    document.querySelectorAll('select').forEach((el) => {
        el.addEventListener('change', () => {
            if (el.value.trim().length > 0) el.classList.add('selected');
            else el.classList.remove('selected');
        })
    });

    const route = new URL(window.location.href)
    const scrollEl = (route.searchParams.get('scroll-to') || '').trim();
    if (scrollEl.length > 0) {
        const offset = parseInt((route.searchParams.get('offset') || '100'));
        animateScrollTo(document.getElementById(scrollEl), offset)
    }

    //We use jQuery here because project is based on Bootstrap version 4 who's not supported native js
    $('.modal').on('show.bs.modal', () => {
        toggleScroll(true)
    }).on('hidden.bs.modal', () => {
        toggleScroll(false)
    });

    document.querySelectorAll<HTMLElement>('.modal[data-animate]').forEach((el) => {
        const animation = el.getAttribute('data-animate');
        let duration = el.getAttribute('data-duration');

        if (duration && duration.includes('ms')) duration = duration.replace('ms', '');

        el.style.setProperty('--animation', animation || 'fadeIn');
        el.style.setProperty('--duration', `${parseInt(duration) || 300}ms`);
    })
}

const initFormListeners = () => {
    document.querySelectorAll<HTMLFormElement>('[data-handle-form]').forEach((form) => {
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            Block.merge({backgroundColor: 'rgba(255,255,255,0.2)'});
            let uiBlockSelector = '.custom__form';

            if (form.closest('.form__warpper')) {
                Block.merge({svgColor: '#FFF',})
                uiBlockSelector = '.form__warpper';
            }

            const data = formToJSON(form.elements)
            const phoneInput = form.querySelector<HTMLInputElement>('[data-init-phone]');
            if (phoneInput) {
                data.phone = renderIntlPhoneNumber(phoneInput);
                if (!data.phone.trim()) data.phone = 'invalid';
            }

            fireRequest(
                form.getAttribute('data-action'),
                data, uiBlockSelector, null,
                async () => {
                    const modalView = form.closest('.modal');
                    if (modalView) $(modalView).modal('hide');
                    form.reset();
                    form.querySelectorAll('select').forEach((el) => el.classList.remove('selected'))
                    await fireConfetti();
                    animateScrollTo(document.body);
                }
            ).catch((error) => {
                notifyError(getComonRequestMessage(true), {asFailure: true});
                console.log(error)
            })

            return false;
        })
    });
}


type CollapserType = 'slice' | 'clamp';

interface CollapserParams {
    el: HTMLElement,
    max: number
    mode: CollapserType
}


interface CollapserHandlerParams extends CollapserParams {
    render: boolean,
}

interface CollapserResizeParams extends CollapserParams {
    breakpoint: number
}


let collapserEventController = new AbortController();
const initContentCollapser = () => {
    collapserEventController?.abort();
    collapserEventController = new AbortController();
    const {signal} = collapserEventController;

    const resize = ({el, max, breakpoint, mode}: CollapserResizeParams) => {
        // if (window.scrollY <= breakpoint) {
        //     //show full content
        //     toggleContent({el, render, max})
        // } else {
        //     //hide full content
        // }

        const render = window.innerWidth <= breakpoint;
        el.classList.toggle('hit__breakpoint', render);
        toggleContent({el, render: render, max, mode})
    }

    const setStyle = (previewNode: HTMLElement, max: number | null) => {
        if (max) {
            previewNode.style.overflow = 'hidden';
            previewNode.style.display = '-webkit-box';
            previewNode.style.webkitLineClamp = max.toString();
            // noinspection JSDeprecatedSymbols
            previewNode.style.webkitBoxOrient = 'vertical';
        } else {
            previewNode.style.removeProperty('overflow')
            previewNode.style.removeProperty('display')
            previewNode.style.removeProperty('webkitLineClamp')
            previewNode.style.removeProperty('webkitBoxOrient')
            previewNode.style.webkitLineClamp = 'none'; //fallback
            // noinspection JSDeprecatedSymbols
            previewNode.style.webkitBoxOrient = 'unset'; //fallback
        }
    }

    const toggleContent = ({el, render, max, mode}: CollapserHandlerParams) => {
        const fullContent = el.querySelector<HTMLInputElement>('input[name="__full__"]').value;
        const previewNode = el.querySelector<HTMLElement>('[data-content]');
        const handler = el.querySelector<HTMLElement>('[data-handler]');

        if (render) {
            handler.textContent = '[ Voir Moins ]';
            previewNode.innerHTML = fullContent;
            el.classList.add('full');
            previewNode.classList.remove('preview__mode');
            setStyle(previewNode, null);
        } else {
            handler.textContent = '[ Voir Plus ]';
            previewNode.classList.add('preview__mode');
            el.classList.remove('full')

            if (mode === 'clamp') {
                setStyle(previewNode, max);
                previewNode.innerHTML = fullContent;
            } else {
                setStyle(previewNode, null);
                previewNode.innerHTML = fullContent?.slice(0, (max - 3)) + '...';
            }
        }
    }

    document.querySelectorAll<HTMLElement>('[data-init-collapser]').forEach((el) => {
        const fullContent = el.textContent.trim();
        const breakOn = parseInt(el.getAttribute('data-breakpoint') || '768');
        const max = parseInt(el.getAttribute('data-max') || '300');

        const rawCutType = (el.getAttribute('data-cut') || 'slice').toLowerCase();
        const cutType: CollapserType = rawCutType === 'clamp' ? 'clamp' : 'slice';

        const shouldRenderHandler = (cutType === 'slice' && fullContent.length > max);
        el.classList.toggle('no__handler', shouldRenderHandler);

        el.replaceChildren();
        el.innerHTML = `
            <div data-content></div>
            <div data-handler>[ Voir Plus ]</div>
            <input type="hidden" name="__full__" value="${fullContent}">
        `;

        resize({el, max, breakpoint: breakOn, mode: cutType});

        window.addEventListener('resize', () => {
            resize({el, max, breakpoint: breakOn, mode: cutType})
        }, {signal})

        el.querySelector('[data-handler]')?.addEventListener('click', () => {
            toggleContent({el, render: !el.classList.contains('full'), max, mode: cutType})
        }, {signal});
    });
}

export const initGlobalViewListeners = () => {
    globalListeners();
    initFormListeners();
    initContentCollapser();
}


export default initGlobalViewListeners;